module.exports = __webpack_public_path__ + "static/nurs-journey-61c2913e6c87928945f805906b82531e.png";